// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"9c35e555","140":"223178fb","258":"8bbc4634","263":"597ae341","447":"792e87ca","453":"9aaade46","456":"3ea5b722","531":"70c66b52","585":"d0d57d08","900":"b0dfad0e","995":"5436bf5e"}[chunkId] + ".chunk.js";
};